/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Critical_Thinking16Inputs */

const en_job_form_enum_critical_thinking16 = /** @type {(inputs: Job_Form_Enum_Critical_Thinking16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Critical Thinking`)
};

const de_job_form_enum_critical_thinking16 = /** @type {(inputs: Job_Form_Enum_Critical_Thinking16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritisches Denken`)
};

/**
* | output |
* | --- |
* | "Critical Thinking" |
*
* @param {Job_Form_Enum_Critical_Thinking16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_critical_thinking16 = /** @type {((inputs?: Job_Form_Enum_Critical_Thinking16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Critical_Thinking16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_critical_thinking16(inputs)
	return en_job_form_enum_critical_thinking16(inputs)
});
export { job_form_enum_critical_thinking16 as "job_form_enum_CRITICAL_THINKING" }